"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFooterBackground = void 0;
var getFooterBackground = function (colors, brand) {
    if (brand === 'valtra') {
        return colors.primary.black;
    }
    if (brand === 'fendt') {
        return colors.grays[800];
    }
    return colors.primary.grays[800];
};
exports.getFooterBackground = getFooterBackground;
